import React from 'react';

type IconProps = {
    color?: string;
    width?: number;
    height?: number;
};

const IconCopy: React.FC<IconProps> = ({ color = '#888888', width = 12, height = 13 }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 12 13"
            fill="none"
        >
            <path
                d="M8.53126 0C8.48089 0 3.65625 0 3.65625 0C2.79662 0 2.03126 0.788537 2.03126 1.62501L1.56163 1.63598C0.702407 1.63598 0 2.41353 0 3.25V11.375C0 12.2115 0.765378 13 1.62501 13H7.71876C8.57837 13 9.34375 12.2115 9.34375 11.375H9.75C10.6096 11.375 11.375 10.5865 11.375 9.75002V3.25976L8.53126 0ZM7.71876 12.1875H1.62501C1.19845 12.1875 0.812514 11.789 0.812514 11.375V3.25C0.812514 2.83604 1.15986 2.45091 1.58642 2.45091L2.03126 2.4375V9.75002C2.03126 10.5865 2.79662 11.375 3.65625 11.375H8.53126C8.53126 11.789 8.14531 12.1875 7.71876 12.1875ZM10.5625 9.75002C10.5625 10.164 10.1766 10.5625 9.75 10.5625H3.65625C3.22968 10.5625 2.84375 10.164 2.84375 9.75002V1.62501C2.84375 1.21105 3.22968 0.812514 3.65625 0.812514H7.71876C7.71224 1.74811 7.71876 2.44767 7.71876 2.44767C7.71876 3.29186 8.47843 4.06251 9.34375 4.06251C9.34375 4.06251 9.7752 4.06251 10.5625 4.06251V9.75002ZM9.34375 3.25C8.91111 3.25 8.53126 2.46392 8.53126 2.04222C8.53126 2.04222 8.53126 1.61484 8.53126 0.825097V0.824279L10.5625 3.25H9.34375ZM8.53126 5.69483H4.87501C4.65076 5.69483 4.46876 5.87642 4.46876 6.10067C4.46876 6.32491 4.65076 6.50651 4.87501 6.50651H8.53126C8.7555 6.50651 8.9375 6.3249 8.9375 6.10067C8.9375 5.87642 8.7555 5.69483 8.53126 5.69483ZM8.53126 7.72404H4.87501C4.65076 7.72404 4.46876 7.90563 4.46876 8.12986C4.46876 8.35413 4.65076 8.53572 4.87501 8.53572H8.53126C8.7555 8.53572 8.9375 8.35413 8.9375 8.12986C8.9375 7.90563 8.7555 7.72404 8.53126 7.72404Z"
                fill={color}
            />
        </svg>
    );
};

export default IconCopy;
